module.exports = __webpack_public_path__ + "public/img/unvf.73f21885.png";